import { render, staticRenderFns } from "./SupplierSaveEditDialog.vue?vue&type=template&id=50400a56"
import script from "./SupplierSaveEditDialog.vue?vue&type=script&lang=js"
export * from "./SupplierSaveEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports